import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, OverlayLoader, UiButton, titleCase } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";


const Inventory = NiceModal.create(
  ({ data }) => {
    const [state, setState] = useState({ count: 0 });
    const modal = useModal();

    const schema = yup.object().shape({
      name: yup.string().required("Enter name of item"),
      type: yup.string().required("Select type"),
      tax_preference: yup.string().required("Select tax preference"),
      selling_price: yup.string().nullable().when('selling_price', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9.]+$/, "Enter selling price")
          .min(0, 'Negative value not allowed')

      }),



      hsn: yup.string().nullable().when('hsn', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9]+$/, "Enter hsn")
          .min(0, 'Negative value not allowed')

      }),

      opening_stock: yup.string().nullable().when('opening_stock', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9]+$/, "Enter opening stock")
          .min(0, 'Negative value not allowed')

      }),

      stock_value: yup.string().nullable().when('opening_stock', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9.]+$/, "Enter stock value")
          .min(0, 'Negative value not allowed')

      }),


      gst: yup.string().nullable().when('tax_preference', {
        is: (value) => 'Taxable' == value,
        then: (rule) => rule
          .required("Select gst")

      }),

      unit: yup.string().nullable().required("Select unit"),

    }, [['selling_price', 'selling_price'], ['hsn', 'hsn'], ['opening_stock', 'opening_stock']]);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      setValue,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      setState({ ...state, loader: true });

      instance({
        method: "post",
        url: "/update_item",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            useStore.setState({ load_items: false });
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };
    useEffect(() => {

      if (data) {
        //)
        reset(data)

      }


    }, [data]);

    const watchPref = watch('tax_preference')
    const watchType = watch('type')

    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Inventory</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          <form id="itemform" onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="row">
              <div className="col-8">
                <UiInput
                  label="Name"
                  type="text"
                  name="name"
                  required
                  {...register("name", { onBlur: (e) => setValue('name', titleCase(e.target.value)) })}
                  message={errors.name?.message}
                />
              </div>
              <div className="col-4">
                <UiSelect
                  label='Type'
                  required
                  name="type"
                  message={errors.type?.message}
                  options={["Product", "Service"]}
                  {...register(`type`)}
                />
              </div>
            </div>
              <UiSelect
                label='Unit'
                name="unit"
                message={errors.unit?.message}
                options={["Pcs", "Kg", "Ml", "Litre", "Meter", "Pack","Set","Sqft","Gm","Box"]}
                {...register(`unit`)}
              />
         
            <div className="row">

              <div className="col-6">
                <UiInput
                  label="HSN"
                  type="text"
                  name="hsn"
                  {...register("hsn")}
                  message={errors.hsn?.message}
                />
              </div>
              <div className="col-6">
                <UiInput
                  label="Selling Price"
                  type="text"
                  name="selling_price"
                  {...register("selling_price")}
                  message={errors.selling_price?.message}
                />
              </div>

            </div>
            {watchType == 'Product' && (


              <div className="row" >

                <div className="col-6">
                  <UiInput
                    label="Opening Stock"
                    type="text"
                    name="opening_stock"
                    {...register("opening_stock")}
                    message={errors.opening_stock?.message}
                  />
                </div>
                <div className="col-6">
                  <UiInput
                    label="Opening Stock Value"
                    type="text"
                    name="stock_value"
                    {...register("stock_value")}
                    message={errors.stock_value?.message}
                  />

                </div>
              </div>
            )}






            <UiSelect
              label='Tax Preference'
              required
              name="tax_preference"
              message={errors.tax_preference?.message}
              options={["Taxable", "Non Taxable"]}
              {...register(`tax_preference`)}
            />

            {watchPref == 'Taxable' && (



              <UiSelect
                label='GST Percentage'
                name="gst"
                message={errors.gst?.message}
                //defaultValue={value.machine}
                options={["5", "12", "18", "28"]}
                {...register(`gst`)}
              />

            )}



            {data && (<input type="hidden" value={data.id} name="id" {...register("id")} />)}
            <UiButton className="btn btn-primary" type="submit" title="Save" />

          </form>
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Inventory;
